import { Component, OnInit } from '@angular/core';
import { SearchObject } from '../../services/Rest';
import { BaseComponent } from '../base/base.component';
import { forkJoin } from 'rxjs';
import { Requisition } from '../../models/RestModels';
import { Store } from '../../models/RestModels';
import { RequisitionInfo } from 'src/app/models/models';
import { Utils } from 'src/app/classes/Utils';
import { filter, mergeMap } from 'rxjs/operators';

interface ExtendedRequisition extends Requisition
{
	to_from_store_id:number;
}

export interface RequisitionInfo2 extends RequisitionInfo
{
	date_string?: string;
}

@Component({
	selector: 'app-list-requisition',
	templateUrl: './list-requisition.component.html',
	styleUrls: ['./list-requisition.component.css']
})

export class ListRequisitionComponent extends BaseComponent implements OnInit
{


	requisition_search:SearchObject<ExtendedRequisition> = this.getEmptySearch();

	requisition_info_list:RequisitionInfo2[] = [];
	type:'requisition'|'store' = 'requisition';
	store_list:Store[] = [];
	status_string = {
		'PENDING':'Pendiente',
		'SHIPPED':'Enviado',
		'CANCELLED':'Cancelado',
		'NOT_APPROVED':'No aprobado',
		'CLOSED':'Cerrada',
		'APPROVED':'Aprobado',
	};
	requisition_titles: Map<RequisitionInfo, string> = new Map();

	selected_requisition_info: RequisitionInfo | null = null;
	show_clone_requisition: boolean = false;

	ngOnInit()
	{
		this.path = '/list-requisition/store';

		let fields = [ "id","status","required_by_store_id","requested_to_store_id","date","created_by_user_id","updated_by_user_id","created","updated" ];

		this.subs.sink = this.getQueryParamObservable().pipe
		(
			mergeMap(([query_param_map, params_map]) =>
			{
				this.type = params_map.get('type') as ('requisition' | 'store');
				this.path = '/list-requisition/' + this.type;
				this.requisition_search = this.getSearch(query_param_map, fields );
				if( this.requisition_search.sort_order.length == 0 )
					this.requisition_search.sort_order = ['id_DESC'];

				if (this.type === 'requisition')
				{
					if ( !this.rest.current_permission.global_requisition )
					{
						this.requisition_search.eq.required_by_store_id = this.rest.current_user.store_id;
					}
					this.requisition_search.is_null.push('requested_to_store_id');
				}
				else
				{
					if( !( this.requisition_search.eq.requested_to_store_id || this.requisition_search.eq.required_by_store_id ) )
					{
						this.requisition_search.eq.to_from_store_id = this.rest.current_user.store_id;
					}

					this.requisition_search.nn.push('requested_to_store_id');
				}

				this.setTitle('Requisiciones');
				this.is_loading = true;
				this.current_page = this.requisition_search.page;

				this.is_loading = true;
				return forkJoin
				({
					requisition : this.rest.requisition_info.search(this.requisition_search),
					store : this.rest.getStores(false),
				})
			})
		)
		.subscribe
		({
			error:(error)=>this.showError(error),
			next:(responses)=>
			{
				const currentYear = new Date().getFullYear();
				this.requisition_info_list = responses.requisition.data.map((ri: RequisitionInfo2) => {
					const d = ri.requisition.required_by_timestamp ? new Date(ri.requisition.required_by_timestamp) : null;

					if (d)
					{
						const options: Intl.DateTimeFormatOptions = d.getFullYear() === currentYear
							? { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }
							: { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true };
						ri.date_string = d.toLocaleString('es-MX', options);
					}
					else
					{
						ri.date_string = '';
					}
					return ri;
				});
				this.setPages( this.requisition_search.page, responses.requisition.total );
				this.store_list = responses.store.data;
				this.is_loading = false;
				this.updateRequisitionTitles();
			}
		});
	}

	showCancelar(ri:RequisitionInfo)
	{
		this.subs.sink = this.confirmation
		.showConfirmAlert(ri, 'Cancelar Requisicion', 'Esta seguro de querer cancelar la requisicion')
		.subscribe((r)=>
		{
			if( r.accepted )
			{
				let prev = ri.requisition.status;
				ri.requisition.status = 'CANCELLED';
				ri.requisition.approved_status = 'NOT_APPROVED';
				ri.requisition.required_by_timestamp = Utils.getUTCMysqlStringFromDate(new Date(ri.requisition.required_by_timestamp));
				this.subs.sink = this.rest.requisition_info
				.update( ri )
				.subscribe(()=>
				{
					this.showSuccess('Se canceló con éxito');
				},(error)=>
				{
					ri.requisition.status = prev;
					this.showError(error);
				});
			}
		});
	}

	showClone(ri:RequisitionInfo)
	{
		this.selected_requisition_info = ri;
		this.show_clone_requisition = true;
	}

	cloneRequistion(evt: Event)
	{
		evt.preventDefault();
		evt.stopPropagation();
	}

	confirmCopy(ri: RequisitionInfo)
	{
		this.subs.sink = this.confirmation
		.showConfirmAlert(ri,'Copiar Requisición','Esta seguro de querer copiar la requisición?')
		.subscribe((response)=>
		{
			if( response.accepted )
			{
				let ri_copy:RequisitionInfo = {
					requisition: { ...ri.requisition, created_by_user_id: this.rest.current_user.id },
					items: ri.items.map((rii)=>
					{
						let rii_item = {requisition_item : rii.requisition_item }
						rii_item.requisition_item.id = 0;

						return {...rii, irequisition_item: rii.requisition_item};
					})
				};

				ri_copy.requisition.id = 0;
				ri_copy.requisition.status = 'PENDING';
				ri_copy.requisition.approved_status = 'PENDING';
				let date = new Date();
				date.setHours(0,0,0,0);
				ri_copy.requisition.required_by_timestamp = Utils.getUTCMysqlStringFromDate(date);

				this.subs.sink = this.rest.requisition_info.create( ri_copy )
				.subscribe((response)=>
				{
					this.showSuccess('La requisicion se copio exitosamente');
					this.router.navigate(['/edit-requisition',response.requisition.id]);
				});
			}
		});
	}

	confirmApproved(ri: RequisitionInfo)
	{
		this.subs.sink = this.confirmation
		.showConfirmAlert(ri,'Aprobar Requisición','Esta seguro de querer aprobar la requisición?')
		.pipe
		(
			filter((response)=>response.accepted),
			mergeMap((_response)=>
			{
				ri.requisition.approved_status = 'APPROVED';
				return this.rest.requisition_info.update( ri )
			})
		)
		.subscribe
		({
			next:()=>
			{
				this.rest.sendNotification('requisition', ri.requisition.id );
				this.showSuccess('Se aprobó con éxito');
			},
			error:(error)=>
			{
				ri.requisition.approved_status = 'PENDING';
				this.showError(error);
			}
		});
	}

	getStatusIcon(ri: RequisitionInfo): string
	{
		if (ri.requisition.status === 'CANCELLED')
		{
			return 'x-circle';
		}

		if (ri.requisition.status === 'SHIPPED')
		{
			return 'truck';
		}

		switch (ri.requisition.approved_status)
		{
			case 'PENDING':
				return 'clock';
			case 'APPROVED':
				return 'shield-check';
			case 'NOT_APPROVED':
				return 'stop-circle';
			default:
				return 'clock';
		}
	}

		getStatusText(ri: RequisitionInfo): string
		{
			if (ri.requisition.status === 'CANCELLED')
			{
				return this.status_string[ri.requisition.status];
			}

			return this.status_string[ri.requisition.approved_status] || 'Desconocido';
		}

	updateRequisitionTitles(): void
	{
		this.requisition_titles.clear();
		this.requisition_info_list.forEach(ri => {
			this.requisition_titles.set(ri, this.getStatusText(ri));
		});
	}

	getRequisitionTitle(ri: RequisitionInfo): string
	{
		return this.requisition_titles.get(ri) || 'Desconocido';
	}

	getSolicitadoATitle(ri: RequisitionInfo): string
	{
		return `Solicitado a: ${ri?.requested_to_store?.name || 'N/A'}`;
	}

	getRequeridoEnTitle(ri: RequisitionInfo): string
	{
		return `Requerido en: ${ri.required_by_store?.name || 'N/A'}`;
	}

	getFechaTitle(ri: RequisitionInfo): string
	{
		const date = ri.requisition.required_by_timestamp ?
			new Date(ri.requisition.required_by_timestamp).toLocaleString() :
			'N/A';
		return `Fecha: ${date}`;
	}

	getNotaTitle(ri: RequisitionInfo): string
	{
		return `Nota: ${ri.requisition.note || 'Sin nota'}`;
	}
}
